import { useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Segnala() {
  const { user } = useAuth();
  const [email, setEmail] = useState(user?.email || "");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (sending) return;
    setSending(true);
    try {
      await api.post("/reports", { email, message });
      setSent(true);
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Invio non riuscito. Riprova tra poco.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto px-4 lg:px-8 py-16 sm:py-20" data-testid="segnala-page">
      <div className="mb-10">
        <p className="eyebrow">Assistenza</p>
        <h1 className="font-display text-4xl text-amber-100 mt-3">Segnala un problema</h1>
        <p className="text-purple-200/70 mt-2 text-sm">
          Descrivi ciò che non ha funzionato. Virginia legge personalmente ogni segnalazione.
        </p>
      </div>
      {sent ? (
        <div className="mystic-card p-6 text-center" data-testid="segnala-success">
          <p className="text-amber-200 font-medium">Segnalazione inviata.</p>
          <p className="text-purple-200/70 text-sm mt-2">Grazie: la leggeremo il prima possibile e ti risponderemo via email.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="mystic-card p-6 space-y-5">
          <div>
            <label htmlFor="segnala-email" className="font-cinzel text-[11px] tracking-[0.25em] uppercase text-amber-400/80 block mb-2">
              La tua email
            </label>
            <input
              id="segnala-email"
              data-testid="segnala-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mystic-input w-full"
            />
          </div>
          <div>
            <label htmlFor="segnala-message" className="font-cinzel text-[11px] tracking-[0.25em] uppercase text-amber-400/80 block mb-2">
              Il problema riscontrato
            </label>
            <textarea
              id="segnala-message"
              data-testid="segnala-message-input"
              required
              minLength={10}
              maxLength={2000}
              rows={6}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="mystic-input w-full resize-y"
            />
          </div>
          <button
            type="submit"
            data-testid="segnala-submit-btn"
            disabled={sending}
            className="gold-btn px-8 py-3 text-sm tracking-wide disabled:opacity-50"
          >
            {sending ? "Invio in corso…" : "Invia segnalazione"}
          </button>
        </form>
      )}
    </div>
  );
}
